import React from 'react';
import { processSteps } from '../data/mock';
import { CheckCircle, ArrowRight } from 'lucide-react';

const Process = () => {
  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Your Journey to
            <span className="text-orange-500"> Financial Clarity</span>
          </h2>
          <p className="text-xl text-gray-600">
            A structured, transparent process designed to make your transition to Germany seamless and stress-free.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Line - Desktop */}
          <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-orange-200 via-orange-300 to-orange-200"></div>

          {/* Steps */}
          <div className="space-y-12">
            {processSteps.map((step, index) => {
              const isEven = index % 2 === 0;
              return (
                <div
                  key={step.id}
                  className={`relative flex items-center ${
                    isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  } flex-col`}
                >
                  {/* Content Card */}
                  <div
                    className={`w-full lg:w-5/12 ${
                      isEven ? 'lg:pr-12 lg:text-right' : 'lg:pl-12 lg:text-left'
                    }`}
                  >
                    <div className="bg-white p-6 rounded-xl shadow-lg border-2 border-gray-100 hover:border-orange-200 hover:shadow-xl transition-all duration-300 group">
                      <div
                        className={`inline-block px-3 py-1 bg-orange-100 text-orange-600 text-sm font-semibold rounded-full mb-3`}
                      >
                        {step.duration}
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-orange-500 transition-colors">
                        {step.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>

                  {/* Center Circle */}
                  <div className="absolute left-1/2 transform -translate-x-1/2 hidden lg:flex items-center justify-center w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full shadow-lg z-10 border-4 border-white">
                    <span className="text-white font-bold text-xl">{step.id}</span>
                  </div>

                  {/* Mobile Number */}
                  <div className="flex lg:hidden items-center justify-center w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full shadow-lg mb-4">
                    <span className="text-white font-bold text-lg">{step.id}</span>
                  </div>

                  {/* Empty space for alternating layout */}
                  <div className="hidden lg:block w-5/12"></div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-20 text-center">
          <div className="inline-flex flex-col items-center max-w-2xl p-10 bg-gradient-to-br from-gray-50 to-orange-50/30 rounded-2xl border-2 border-orange-100">
            <CheckCircle className="w-16 h-16 text-orange-500 mb-4" />
            <h3 className="text-2xl font-bold text-gray-900 mb-3">
              Ready to Get Started?
            </h3>
            <p className="text-gray-600 mb-6 text-lg">
              Book your free 45-minute consultation and take the first step toward clarity and confidence in your German financial journey.
            </p>
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
            >
              Schedule Your Free Consultation
              <ArrowRight className="ml-2 w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
